<template>
  <div class="mv">
    <div class="mv_inner">
      <div class="mv_message">
        <h2>
          <img
            class="mv_lead"
            src="@/assets/images/home/mv_lead.svg"
            alt="未来のドクターへ、期待以上の出会いを。"
          />
          <p class="mv_text">
            医学生や研修医一人ひとりにとって、理想の現場との出会いをつくることで、日本の医療に貢献したい。<br />
            私たちはマイナビRESIDENTです。
          </p>
        </h2>
      </div>
      <div class="topNews" v-if="news.length > 0">
        <div class="topNews_slideWrap">
          <ul class="topNews_slide">
            <template v-for="(item, i) in news" :key="i">
              <li v-show="currentNews === i + 1">
                <router-link :to="`/news/detail/${item.id}`">
                  <dl class="topNews_item">
                    <dt>{{ item.displayDate }}</dt>
                    <dd>{{ item.title }}</dd>
                  </dl>
                </router-link>
              </li>
            </template>
          </ul>
        </div>
        <div class="topNews_controls">
          <button
            type="button"
            class="topNews_prev"
            :disabled="currentNews === 1"
            @click="currentNews--"
          ></button>
          <button
            type="button"
            class="topNews_next"
            :disabled="currentNews === news.length"
            @click="currentNews++"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'HomeMainVisual',

  setup() {
    const store = useStore()
    const currentNews = ref<number>(1)
    return {
      currentNews,
      news: computed(() => store.getters['home/getNewsTopics'])
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mv {
  height: 370px;
  background: url('~@/assets/images/home/bg_mv_sm.jpg') no-repeat;
  background-size: cover;

  @include mixins.media('sm') {
    background: url('~@/assets/images/home/bg_mv_lg.jpg') center center
      no-repeat;
    background-size: cover;
    height: 400px;
  }

  @include mixins.media() {
    background-image: url('~@/assets/images/home/bg_mv_lg.jpg'),
      url('~@/assets/images/home/bg_mv_lg_sky.jpg');
    background-position: center center, center center;
    background-repeat: no-repeat, repeat-x;
    background-size: auto 500px, auto 500px;
    height: 500px;
  }

  &_inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 16px;
    margin-left: auto;
    margin-right: auto;

    @include mixins.media('sm') {
      padding: 20px;
      max-width: 940px;
    }
  }
}

.mv_message {
  width: 294px;
  margin-bottom: 20px;

  @include mixins.media('sm') {
    width: 320px;
    margin-bottom: 40px;
  }

  @include mixins.media() {
    width: 450px;
    margin-bottom: 70px;
  }
}

.mv_lead {
  display: block;
  width: 100%;
}

.mv_text {
  display: none;

  @include mixins.media('sm') {
    display: block;
    font-size: 1.4rem;
    font-weight: normal;
    margin-top: 22px;
  }
}

.topNews {
  position: relative;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-size: 1.1rem;
  line-height: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.topNews_slideWrap {
  overflow: hidden;
  width: 100%;
  height: 50px;

  @include mixins.media('sm') {
    height: 66px;
  }
}

.topNews_slide {
  height: 100%;

  li {
    width: 100%;
    height: 100%;
  }

  a {
    display: flex;
    height: 100%;
    align-items: center;
  }
}

.topNews_item {
  min-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-left: 16px;
  padding-right: 16px;

  dt {
    margin-bottom: 5px;
    font-size: 1rem;

    @include mixins.media('sm') {
      margin-bottom: 8px;
      font-size: 1.2rem;
    }
  }

  dd {
    font-size: 1.1rem;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 10px;

    @include mixins.media('sm') {
      font-size: 1.4rem;
    }
  }
}

.topNews_controls {
  display: flex;
  justify-content: space-between;
  flex: 0 0 61px;
  background-color: #e4e4e4;
  width: 61px;
  position: relative;

  &::before {
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    display: inline-block;
    content: '';
    width: 1px;
    height: 20px;
    background-color: #ccc;
  }
}

.topNews_prev,
.topNews_next {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 50px;

  @include mixins.media('sm') {
    height: 66px;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
  }

  &:disabled {
    pointer-events: none;
    &::after {
      border-color: #ccc;
    }
  }
}

.topNews_prev {
  padding-left: 4px;

  &::after {
    border-left: 2px solid #999;
    border-top: 2px solid #999;
    transform: rotate(-45deg);
    transition: border-color 0.1s;
  }
}

.topNews_next {
  &::after {
    border-right: 2px solid #999;
    border-bottom: 2px solid #999;
    transform: rotate(-45deg);
    transition: border-color 0.1s;
    margin-right: 4px;
  }
}
</style>
